// removed by extract-text-webpack-plugin
module.exports = {"sul-container":"sul-list__sul-container__2d2DL","loading-container":"sul-list__loading-container__3VCYo","list-title":"sul-list__list-title__1OBH5","ul-container":"sul-list__ul-container__1lYYp","li-container":"sul-list__li-container__5LSNg","sul-name":"sul-list__sul-name__3Mf-3","name":"sul-list__name__OF81W","notes":"sul-list__notes__kX7e3","button-wrapper":"sul-list__button-wrapper__e2_kB","button-inner":"sul-list__button-inner__1RlKy"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/event/CreateEvent/FirstStep/SULList/sul-list.scss
// module id = 1524
// module chunks = 1